import {useEffect} from "react";

import {hitGTMPropertyViewItemList, IHitGTMPropertyViewItemListParams} from "../../offer/tracking/ecommerce_events/property/hit_gtm_property_view_item_list";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {useElementViewportShowingUpStatus} from "./use_element_viewport_showing_up_status";

interface IPropertiesTrackingParams {
    offer: IHitGTMPropertyViewItemListParams["offer"];
    properties: IPropertyListProperty[];
    listId: string;
    listName: string;
    useVisibilityTracking: boolean;
    isListReady?: boolean;
}

/**
 * If useVisibilityTracking is true, the event will be sent when the element becomes visible.
 * If false, the event will be sent immediately on mount.
 * Pass the returned containerId on the HTML element that should be watched to trigger the event.
 */
export const useGTMEcommercePropertyListViewTracking = (params: IPropertiesTrackingParams) => {
    const {useVisibilityTracking, isListReady = true} = params;
    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking});

    useEffect(() => {
        if (isWaitingForElement || !params.offer || !params.properties.length || !isListReady) {
            return;
        }

        hitGTMPropertyViewItemList({
            offer: params.offer,
            properties: params.properties,
            listId: params.listId,
            listName: params.listName
        });
    }, [
        // We don't need to add params.offer - params.properties is enough, params.offer may cause a double hit
        isWaitingForElement,
        params.properties.map((property) => property.id).join(","),
        params.listId,
        params.listName,
        isListReady
    ]);

    return {containerId};
};
import {useEffect} from "react";

import {hitGTMPropertyViewItemList, IHitGTMPropertyViewItemListParams} from "../../offer/tracking/ecommerce_events/property/hit_gtm_property_view_item_list";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {useElementViewportShowingUpStatus} from "./use_element_viewport_showing_up_status";

interface IPropertiesTrackingParams {
    offer: IHitGTMPropertyViewItemListParams["offer"];
    properties: IPropertyListProperty[];
    listId: string;
    listName: string;
    useVisibilityTracking: boolean;
    isListReady?: boolean;
}

/**
 * If useVisibilityTracking is true, the event will be sent when the element becomes visible.
 * If false, the event will be sent immediately on mount.
 * Pass the returned containerId on the HTML element that should be watched to trigger the event.
 */
export const useGTMEcommercePropertyListViewTracking = (params: IPropertiesTrackingParams) => {
    const {useVisibilityTracking, isListReady = true} = params;
    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking});

    useEffect(() => {
        if (isWaitingForElement || !params.offer || !params.properties.length || !isListReady) {
            return;
        }

        hitGTMPropertyViewItemList({
            offer: params.offer,
            properties: params.properties,
            listId: params.listId,
            listName: params.listName
        });
    }, [
        // We don't need to add params.offer - params.properties is enough, params.offer may cause a double hit
        isWaitingForElement,
        params.properties.map((property) => property.id).join(","),
        params.listId,
        params.listName,
        isListReady
    ]);

    return {containerId};
};
